import { PlanClass } from '@/enums';
import { getCountryName } from '@/helpers/CountryCodeHelper';
import { useAppSelector } from '@/hook';
import { useTranslation } from 'react-i18next';

export const PlanHighlight = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'planhighlight',
  });

  const areaId = useAppSelector(
    (state) => state.planSummary.quotationDetail?.areaId,
  );
  const area = areaId == PlanClass.Domestic ? 'domestic' : 'international';

  return [
    {
      key: 'death',
      label: t('death.label'),
      description: t('death.description'),
    },
    {
      key: 'medical',
      label: t('medical.label'),
      description: t('medical.description'),
      tooltips: t('medical.tooltips'),
    },
    {
      key: 'lossOrDamageBaggage',
      label: t('loss.label'),
      description: t('loss.description'),
      tooltips: t('loss.tooltips'),
    },
    {
      key: 'baggageDelay',
      label: t('baggage.label'),
      description: t(`baggage.${area}.description`, {
        country: getCountryName(),
      }),
    },
    {
      key: 'travelDelay',
      label: t('delay.label'),
      description: t('delay.description'),
      tooltips: t('delay.tooltips'),
    },
    {
      key: 'travelCancellation',
      label: t('cancel.label'),
      description: t('cancel.description'),
      tooltips: t('cancel.tooltips'),
    },
    {
      key: 'missedConnection',
      label: t('missed.label'),
      description: t('missed.description'),
    },
    {
      key: 'etiqaApp',
      badge: t('new.badge'),
      label: t('etiqa.label'),
      description: t('etiqa.description'),
    },
  ];
};

export default PlanHighlight;
